export default {
  isOperator: (profile) => {
    return profile.roles !== undefined && profile.roles.filter(role => role === 'operator').length > 0
  }
}



// WEBPACK FOOTER //
// ./src/helpers/AccessControl.js